import httpClient from './httpClient';

const baseEndpoint = '/api/shop/customer'

const saveCustomer = request => {
    return httpClient.post(`${baseEndpoint}/save`, request)
}

const fetchCustomerByEmail = email => {
    return httpClient.get(`${baseEndpoint}/secure/`, { params: { email } })
}

const fetchAllCustomers = (page, pageSize) => {
    return httpClient.get(`${baseEndpoint}/secure/all`, { params: { page, pageSize } })
}

export {
    saveCustomer,
    fetchCustomerByEmail,
    fetchAllCustomers
}
